.root {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  align-self: stretch;

  .bubble {
    display: flex;
    padding: 10px 12px;
    align-items: center;
    gap: 8px;

    border-radius: 12px;
    border: 1px solid var(--green-10);
    background: var(--green-10);

    .iconContainer {
      display: flex;
      width: 18px;
      height: 18px;
      justify-content: center;
      align-items: center;
      gap: 11.25px;
      aspect-ratio: 1/1;

      border-radius: 111.375px;
      background: var(--green);

      svg {
        width: 10.125px;
        height: 10.125px;
        flex-shrink: 0;
        aspect-ratio: 1/1;
      }
    }
  }
}
